const brand = {
	100: "#f4f6ff",
	200: "#e1e7ff",
	300: "#b6c1f5",
	400: "#515ba5",
	500: "#3a3879",
	600: "#262a6e",
};

const neutrals = {
	0: "#FFFFFF",
	10: "#FAFBFC",
	15: "#F8F9FA",
	20: "#F4F5F7",
	30: "#EBECF0",
	40: "#DFE1E6",
	50: "#C1C7D0",
	60: "#B3BAC5",
	70: "#A5ADBA",
	80: "#97A0AF",
	90: "#8993A4",
	100: "#7A869A",
	200: "#6B778C",
	300: "#5E6C84",
	400: "#505F79",
	500: "#42526E",
	600: "#344563",
	700: "#253858",
	800: "#172B4D",
	900: "#051839",
};

const accent = {
	blue: {
		100: "#F4F6FF",
	},
	turquoise: {
		100: "#e3f8ff",
		200: "#C5ECF9",
		300: "#3fb6d8",
		400: "#007f9c",
		500: "#006981",
	},
	green: {
		100: "#e8f8ef",
		200: "#a4dbc0",
		300: "#58b78e",
		400: "#268460",
		500: "#1b6f50",
	},
	orange: {
		100: "#fff8ea",
		200: "#fbd892",
		300: "#F2C464",
		400: "#986616",
		500: "#663F00",
	},
	red: {
		100: "#ffeeee",
		200: "#ffdadb",
		300: "#f48b90",
		400: "#B84C56",
		500: "#A03B46",
		600: "#7c2731",
	},
	yellow: {
		100: "#FCFFD6",
		200: "#FFFFA6",
		300: "#FFF03F",
	},
	purple: {
		100: "#FAF1FF",
	},
};

// Semantic colours from Figma
const text = {
	white: neutrals[0],
	paragraph: {
		light: neutrals[200],
		regular: neutrals[500],
	},
	title: neutrals[900],
	regular: neutrals[500],
	link: {
		default: brand[500],
		hover: brand[600],
	},
};

const info = {
	background: accent.turquoise[100],
	icon: accent.turquoise[400],
	title: accent.turquoise[500],
	paragraph: text.paragraph.regular,
	link: text.link.default,
};

const success = {
	background: accent.green[100],
	icon: accent.green[400],
	title: accent.green[500],
	paragraph: text.paragraph.regular,
	plainText: accent.green[500],
	link: text.link.default,
};

const warning = {
	background: accent.orange[100],
	icon: accent.orange[400],
	title: accent.orange[500],
	paragraph: text.paragraph.regular,
	plainText: accent.orange[500],
	link: text.link.default,
};

const error = {
	background: accent.red[100],
	icon: accent.red[400],
	title: accent.red[500],
	paragraph: text.paragraph.regular,
	plainText: accent.red[500],
	link: text.link.default,
};

const form = {
	disabled: {
		background: neutrals[400],
		text: neutrals[400],
	},
	outline: {
		light: neutrals[500],
		dark: neutrals[100],
	},
};

export const colours = {
	brand,
	neutrals,
	accent,
	info,
	success,
	warning,
	error,
	form,
	text,
};

export const qoriaColours = {
	brand: {
		primary: {
			10: "#f4f6ff",
			50: "#e1e7ff",
			100: "#d1d9fd",
			200: "#b6c1f5",
			300: "#9eabeb",
			400: "#7e8ad4",
			500: "#6371bb",
			600: "#515ba5",
			700: "#3a3879",
			800: "#262a6e",
			900: "#110a4e",
		},
		success: {
			10: "#e8f8ef",
			50: "#ceeddd",
			100: "#a4dbc0",
			200: "#7ecaa7",
			300: "#58b78e",
			400: "#3e9f78",
			500: "#268460",
			600: "#1b6f50",
			700: "#00563a",
			800: "#084630",
			900: "#003925",
		},
		info: {
			10: "#e3f8ff",
			50: "#c5ecf9",
			100: "#95daf1",
			200: "#69c9e7",
			300: "#3fb6d8",
			400: "#1da0c1",
			500: "#00719c",
			600: "#006981",
			700: "#004f62",
			800: "#003b49",
			900: "#00232d",
		},
		danger: {
			10: "#ffeeee",
			50: "#ffdadb",
			100: "#ffc5c6",
			200: "#ffafb1",
			300: "#f48b90",
			400: "#d96a71",
			500: "#b84c56",
			600: "#a03b46",
			700: "#7c2731",
			800: "#651a24",
			900: "#4a0513",
		},
		warning: {
			10: "#fff8ea",
			50: "#ffecc6",
			100: "#fbd892",
			200: "#f2c464",
			300: "#dba54d",
			400: "#c38827",
			500: "#986616",
			600: "#84560b",
			700: "#663f00",
			800: "#4d2f00",
			900: "#3d2600",
		},
		neutral: {
			10: "#ffffff",
			50: "#f1f4f9",
			100: "#e2e7f0",
			200: "#d2d9e5",
			300: "#a0acc0",
			400: "#7d8aa1",
			500: "#68758b",
			600: "#495569",
			700: "#2d3748",
			800: "#192234",
			900: "#131b2a",
		},
	},
	accent: {
		blue: {
			10: "#e9f3ff",
			50: "#d8e8ff",
			100: "#b4d6ff",
			200: "#8ec2ff",
			300: "#58a6ff",
			400: "#2591ff",
			500: "#0075db",
			600: "#005fb4",
			700: "#00427f",
			800: "#002c58",
			900: "#001027",
		},
		lime: {
			10: "#ebfdda",
			50: "#cfedad",
			100: "#bae389",
			200: "#9dcd5b",
			300: "#83b435",
			400: "#709f18",
			500: "#598200",
			600: "#436400",
			700: "#304900",
			800: "#233800",
			900: "#121f00",
		},
		tangerine: {
			10: "#ffefe5",
			50: "#ffdec5",
			100: "#ffc59e",
			200: "#ffa86d",
			300: "#fc8338",
			400: "#e66e1c",
			500: "#c15600",
			600: "#9b4200",
			700: "#6d2c00",
			800: "#512000",
			900: "#310f00",
		},
		magenta: {
			10: "#ffe8ed",
			50: "#ffd9e1",
			100: "#ffbacb",
			200: "#ff9cb6",
			300: "#ff759f",
			400: "#f05187",
			500: "#db2f72",
			600: "#b40056",
			700: "#86003f",
			800: "#60002b",
			900: "#380016",
		},
		orchid: {
			10: "#fff3fa",
			50: "#ffe5f5",
			100: "#ffbbe8",
			200: "#f79dd9",
			300: "#f17ed2",
			400: "#e252bb",
			500: "#c637a1",
			600: "#a51685",
			700: "#7e005e",
			800: "#530041",
			900: "#3a002d",
		},
		turquoise: {
			10: "#ddfbf7",
			50: "#b1f4ec",
			100: "#83eae0",
			200: "#69dcd1",
			300: "#00c5b8",
			400: "#00a297",
			500: "#00837b",
			600: "#006b64",
			700: "#004c47",
			800: "#003632",
			900: "#00201d",
		},
		purple: {
			10: "#faf1ff",
			50: "#f1e0fb",
			100: "#e8c9fc",
			200: "#deabfe",
			300: "#d08bff",
			400: "#bf66ff",
			500: "#a446e9",
			600: "#7d0ec9",
			700: "#6700aa",
			800: "#4c057d",
			900: "#37025d",
		},
		shark: {
			10: "#ffffff",
			50: "#f7f7f7",
			100: "#ededed",
			200: "#d7d7d7",
			300: "#bebebe",
			400: "#949494",
			500: "#707070",
			600: "#515151",
			700: "#393939",
			800: "#272727",
			900: "#171717",
		},
	},
	bg: {},
};
